import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "../../../helpers/classNames";
import navbarItemsRender from "../../../helpers/navbarItemsRender";
import { useEditor } from "../../../hooks/EditorProvider";
import { useSite } from "../../../hooks/SiteProvider";
import { SideEditOptions } from "../../../types/elements";
import { NavbarItemType } from "../../../types/propOptions";
import Link from "../../common/Link";
const DraggableNavbarVertical = ({ item: { props, id }, ...rest }) => {
    const { menus, pages, activePage } = useSite();
    const { mode } = useEditor();
    const menu = menus?.find((m) => m.id === props?.["menu"]?.selected);
    const navbarItems = menu
        ? navbarItemsRender(JSON.parse(menu?.items), pages)
        : null;
    const fallbackItems = [
        {
            href: "#",
            name: mode === "production" ? "Home" : "Geen menu items gevonden",
            id: 1,
            type: NavbarItemType.Link,
        },
    ];
    const navbarItemsRendered = navbarItems || fallbackItems;
    return (_jsx("div", { className: props?.className || "flex flex-1 flex-col", "editor-key": id, "editor-has-childs": "true", "editor-options": JSON.stringify([
            {
                type: "menu",
            },
            {
                type: SideEditOptions.TextColor,
                config: {
                    key: "text-color",
                    valueKey: "textColor",
                    defaultValue: "text-white",
                    label: "Tekst kleur",
                },
            },
            {
                type: SideEditOptions.BackgroundColor,
                config: {
                    key: "bg-active-item",
                    valueKey: "backgroundColor",
                    defaultValue: "bg-site-400",
                    label: "Kleur active item",
                },
            },
            {
                type: SideEditOptions.TextColor,
                config: {
                    key: "text-active-color",
                    valueKey: "textColor",
                    defaultValue: "text-white",
                    label: "Tekst active item kleur",
                },
            },
        ]), "editor-text-color": props?.["text-color"] || "text-black", "editor-bg-active-item": props?.["bg-active-item"] || "bg-site-500", "editor-text-active-color": props?.["text-active-color"] || "text-white", "editor-menu-selected": props?.["menu"]?.selected || null, ...rest, children: _jsx("ul", { role: "list", className: "-mx-2 space-y-1", "editor-focuskey": id, children: navbarItemsRendered?.map((item) => (_jsx("li", { "editor-focuskey": id, children: _jsx(Link, { "editor-focuskey": id, href: item.href, className: classNames(item.href === activePage
                        ? classNames(props?.["bg-active-item"] || "bg-site-500", props?.["text-active-color"] || "text-white")
                        : classNames(props?.["text-color"] || "text-black", "hover:bg-gray-50"), "group flex gap-x-3 rounded-md p-2 pl-3 text-sm font-medium leading-6"), children: item.name }) }, item.id))) }) }));
};
export default DraggableNavbarVertical;
//# sourceMappingURL=DraggableNavbarVertical.js.map